module.exports = __webpack_public_path__ + "img/ALGO.25e6b9cd.svg";